var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 121.938,
    viewBox: "0 0 120 121.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-12, .cls-15, .cls-17, .cls-19 {\n        fill: #fff;\n      }\n\n      .cls-1 {\n        opacity: 0;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #37474f;\n      }\n\n      .cls-18, .cls-19, .cls-4 {\n        opacity: 0.2;\n      }\n\n      .cls-5 {\n        fill: #263238;\n      }\n\n      .cls-16, .cls-18, .cls-6 {\n        fill: #407bff;\n      }\n\n      .cls-7 {\n        fill: #ffa8a7;\n      }\n\n      .cls-8 {\n        fill: #f28f8f;\n      }\n\n      .cls-9 {\n        fill: #455a64;\n      }\n\n      .cls-10 {\n        fill: #fafafa;\n      }\n\n      .cls-11 {\n        fill: #b16668;\n      }\n\n      .cls-12 {\n        opacity: 0.45;\n      }\n\n      .cls-13 {\n        opacity: 0.3;\n      }\n\n      .cls-14 {\n        opacity: 0.15;\n      }\n\n      .cls-15 {\n        opacity: 0.8;\n      }\n\n      .cls-16 {\n        opacity: 0.4;\n      }\n\n      .cls-17 {\n        opacity: 0.6;\n      }\n\n      .cls-20 {\n        fill: #11cda8;\n      }\n\n      .cls-21 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15170",
    "data-name": "Rectangle 15170",
    className: "cls-1",
    width: 120,
    height: 120,
    transform: "translate(-3989 16832)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16733",
    "data-name": "Group 16733",
    transform: "translate(-6513 22918.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illustration",
    transform: "translate(10502 -39749)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4638",
    "data-name": "Rectangle 4638",
    className: "cls-1",
    width: 120,
    height: 120,
    transform: "translate(-3989 16832)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_318",
    "data-name": "Mask Group 318",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2",
    transform: "translate(-4332.004 16677.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chartacter--inject-2",
    transform: "translate(343.995 156.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-2",
    transform: "translate(30.725 89.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57432",
    "data-name": "Path 57432",
    className: "cls-3",
    d: "M439.307,268.029c2.37,25.147,3.465,59.611,3.465,59.611.2,1.9,1.577,5.157,2.64,14.572,1.12,9.938,1.536,20.7,1.536,20.7s-8.769,7.314-14.294,1.545c0,0-4.8-17.121-7.821-28.8-2.86-11.049-5.811-28.972-5.811-28.972l-2.991,16.754s.5,7.167.376,12.193c-.139,5.843-2.027,21.1-2.027,21.1-1.635,3.122-13,3.727-14.809-1.283,0,0-.588-24.322-.874-31.342-.548-13.779-.449-40.519-.27-58.319Z",
    transform: "translate(-384.642 -265.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57433",
    "data-name": "Path 57433",
    className: "cls-4",
    d: "M420.69,310.956l-3.138-17.841s-6.677-.874-10.142-3.956c0,0,2.272,4.086,8.581,5.631l3.089,16.263L417.7,327.71Z",
    transform: "translate(-386.309 -270.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57434",
    "data-name": "Path 57434",
    className: "cls-5",
    d: "M381.86,415.56c.286,1.291,1.267,3.759,6.652,4.479s11.074-1.087,13.673-3.637,2.574-4.691,3.931-5.876,3.441-2.779,3.947-3.62.09-2.885.09-2.885Z",
    transform: "translate(-381.64 -291.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57435",
    "data-name": "Path 57435",
    className: "cls-6",
    d: "M396.53,373.29V375.1s1.046,1.806,6.015,2.64a14.359,14.359,0,0,0,8.8-1.357l.212-1.545s.94-.163.711,1.757-2.01,13.624-2.166,16.075.67,5.1-.09,6.873-3.424,2.656-5,4.993-2.452,6.808-9.889,8.442-11.245-.425-12.8-2.247-.6-3.768,2.411-5.909c3.146-2.239,5.4-3.9,7.609-5.721,2.836-2.3,3.588-3.906,3.588-7.535,0-2.95-.3-14.588-.409-16.133S395.663,373.29,396.53,373.29Z",
    transform: "translate(-381.591 -285.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57436",
    "data-name": "Path 57436",
    className: "cls-4",
    d: "M396.53,373.29V375.1s1.046,1.806,6.015,2.64a14.359,14.359,0,0,0,8.8-1.357l.212-1.545s.94-.163.711,1.757-2.01,13.624-2.166,16.075.67,5.1-.09,6.873-3.424,2.656-5,4.993-2.452,6.808-9.889,8.442-11.245-.425-12.8-2.247-.6-3.768,2.411-5.909c3.146-2.239,5.4-3.9,7.609-5.721,2.836-2.3,3.588-3.906,3.588-7.535,0-2.95-.3-14.588-.409-16.133S395.663,373.29,396.53,373.29Z",
    transform: "translate(-381.591 -285.435)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57437",
    "data-name": "Path 57437",
    className: "cls-5",
    d: "M447.89,429.148c.588,3.269,1.921,5.443,4.593,6.456s6.538-.948,7.641-2.664,2.182-3.915,1.169-8.99Z",
    transform: "translate(-393.707 -294.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57438",
    "data-name": "Path 57438",
    className: "cls-6",
    d: "M439.757,384.577l.335,1.218s2.542,1.193,7.241.646a16.478,16.478,0,0,0,7.053-2.19l-.073-1.561s1-.172,1.136,1.561c.212,2.615.221,14.1.3,17.832s1.872,7.658,3.073,10.959,2.223,9.635-2.452,12.725-8.728,1.005-10.052-3.874c-1.414-5.206-.768-13.3-1.733-17.751a171.63,171.63,0,0,0-5.353-16.95C438.449,385.288,439.757,384.577,439.757,384.577Z",
    transform: "translate(-392.079 -287.152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57439",
    "data-name": "Path 57439",
    className: "cls-4",
    d: "M439.757,384.577l.335,1.218s2.542,1.193,7.241.646a16.478,16.478,0,0,0,7.053-2.19l-.073-1.561s1-.172,1.136,1.561c.212,2.615.221,14.1.3,17.832s1.872,7.658,3.073,10.959,2.223,9.635-2.452,12.725-8.728,1.005-10.052-3.874c-1.414-5.206-.768-13.3-1.733-17.751a171.63,171.63,0,0,0-5.353-16.95C438.449,385.288,439.757,384.577,439.757,384.577Z",
    transform: "translate(-392.079 -287.152)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-2",
    transform: "translate(0 25.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57440",
    "data-name": "Path 57440",
    className: "cls-3",
    d: "M400.933,206.94c-5.369.817-6.293,2.2-14.237,9.063A58.492,58.492,0,0,1,375.255,224s-6.726,8.173-7,9.758-.817,5.181,2.337,7.184c2.019,1.283,4.372.114,5.615.229,2.615.253,4.209-1.863,5.3-2.509,7.355-4.372,14.711-8.361,14.711-8.361Z",
    transform: "translate(-348.388 -191.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57441",
    "data-name": "Path 57441",
    className: "cls-7",
    d: "M346.631,198.862c1.1-.654,1.3.36,1.635.5,0,0-1.136-1.3.76-2.452,1.169-.695,1.741.94,1.765.719,0-.09-1.406-3.424-2.566-6.252-1.1-2.681-.147-3.449.294-3.661s.883,0,1.9,1.921,4,7.8,4.683,8.99,1.161,1.782,1.594.2a8.738,8.738,0,0,1,1.634-3.792c1.438-1.512,2.566-.817,2.337.311-.319,1.635-.294,3.555-.531,6.219-.123,1.389-.147,2.7-.311,3.653-.49,3.351,1.463,4.9,3.792,7.511,1.9,2.149,3.866,3.915,8.238,8.23,4.143,4.086,3.98,13.73-.114,15.422-4.7,1.945-6.538-.531-9.979-5.721-2.893-4.413-6.873-12.447-7.952-14.31s-1.479-3-2.975-3.906a10.927,10.927,0,0,1-4.086-4.536c-.539-.94-1.569-2.672-2.231-4.086s-.744-2.4.065-3c1.087-.817,1.406.392,1.512.27S345.061,199.786,346.631,198.862Z",
    transform: "translate(-343.995 -187.649)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57442",
    "data-name": "Path 57442",
    className: "cls-8",
    d: "M356.882,204.2c-1.52,1.487-2.6,5.525-1.945,8.173C353.041,209.6,354.12,205.491,356.882,204.2Z",
    transform: "translate(-345.82 -190.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57443",
    "data-name": "Path 57443",
    className: "cls-8",
    d: "M351.692,201c.891,1.635,1.741,3.449,1.52,4.184a1.144,1.144,0,0,1-1.365.948,2.207,2.207,0,0,1-.948-.515,1.913,1.913,0,0,1,.221,1.275,1.357,1.357,0,0,1-1.553.695,1.855,1.855,0,0,1-.891-.752s.368.973,0,1.512a1.259,1.259,0,0,1-1.9-.155c.441.768,1.079,1.2,1.872.817s.6-1.013.6-1.013a1.389,1.389,0,0,0,1.553,0,1.422,1.422,0,0,0,.817-1.5,1.316,1.316,0,0,0,2.059-.695c.351-1.013,0-1.741-.654-2.909a8.17,8.17,0,0,0-1.34-1.9Z",
    transform: "translate(-344.504 -190.089)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-2",
    className: "cls-9",
    d: "M427.862,204.9c2.533.523,5.721,1.177,8.99,2.068a49.373,49.373,0,0,1,4.756,1.455s1.716,7.355.711,25.106c-.155,2.623-2.051,9.668-2.378,15.111a87,87,0,0,0,.458,16.974s-6.464,6.219-24.379,4.9c-14.065-1.054-17.71-7.192-17.71-7.192s.155-22.491.523-32.862c.482-13.615,4.6-21.477,7.641-23.864l9.227-1.536Z",
    transform: "translate(-353.921 -165.062)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-2",
    transform: "translate(43.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57444",
    "data-name": "Path 57444",
    className: "cls-3",
    d: "M437.718,169.28a4.887,4.887,0,0,1,3.6,2.9c.711,1.373,1.226,3.882-.736,11.041a29.029,29.029,0,0,1-3.441,7.9,3.563,3.563,0,0,1-2.059,1.634l.147-5.508.2-3.833s-3.1-2.811-3.359-5.565a8.835,8.835,0,0,1,1.038-5.557Z",
    transform: "translate(-403.14 -158.553)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57445",
    "data-name": "Path 57445",
    className: "cls-3",
    d: "M434.2,167.894c-.539-3.1-4.462-6.791-12.038-7.192-6.2-.335-9.652,1.912-11.989,5.418-2.452,3.661-.736,8.3-.736,8.3l19.492-1.275Z",
    transform: "translate(-398.913 -156.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57446",
    "data-name": "Path 57446",
    className: "cls-7",
    d: "M436.014,188.875c-2.852,1.381-4.152-.874-4.152-.874l-.425,11.352c-5.484,7.355-20.1,4.683-14.1-.817v-2.591a16.217,16.217,0,0,1-2.452-.237c-2.525-.4-4.086-2.4-4.863-5.141a38.182,38.182,0,0,1,0-17.416,4.707,4.707,0,0,1,2.092-3.383c3.032-1.5,5.835.662,10.052,2.313,1.749.678,5.99.981,7.11.449-1.471,1.635-1.463,6.767.711,8.851a4.632,4.632,0,0,0,1.087,1.422c.924.817,1.684-1.275,2.452-2.084a3.179,3.179,0,0,1,4.9,1.136,5.19,5.19,0,0,1-2.419,7.02Z",
    transform: "translate(-398.943 -158.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57447",
    "data-name": "Path 57447",
    className: "cls-6",
    d: "M415.1,205.09s-4.209,3.269-6.538,12.324-2.991,35.2-3.065,43.8,0,11.793,0,11.793a28.522,28.522,0,0,1-8.679-2.117c0-10.085-.686-39.555,2.182-50.67s7.216-13.648,7.216-13.648Z",
    transform: "translate(-396.7 -165.097)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57448",
    "data-name": "Path 57448",
    className: "cls-10",
    d: "M396.723,272.846a20.342,20.342,0,0,0,8.7,2.73V272.65a20.807,20.807,0,0,1-8.728-2.958C396.715,270.787,396.723,271.833,396.723,272.846Zm0-11.956v3.465a21.06,21.06,0,0,0,8.8,3.081c0-.948,0-1.986.065-3.073a33.925,33.925,0,0,1-8.867-3.473Z",
    transform: "translate(-396.69 -175.294)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57449",
    "data-name": "Path 57449",
    className: "cls-6",
    d: "M435.213,204.6l-.041,1.21s-3.817,14.31-4.74,26.365c-.973,12.578-.973,46.453-.973,46.453s15.217-.6,18.078-3.9c-.736-12.561-1.545-18.592-.891-27.59s4.381-25.752.891-39.106C444.375,207.166,439.316,205.638,435.213,204.6Z",
    transform: "translate(-402.679 -165.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57450",
    "data-name": "Path 57450",
    className: "cls-10",
    d: "M446.712,274.64c-2.108,1.062-7.919,3.563-17.162,4.38v3.212s10.624-.2,17.408-4.454C446.843,276.691,446.77,275.645,446.712,274.64Z",
    transform: "translate(-402.695 -177.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57451",
    "data-name": "Path 57451",
    className: "cls-8",
    d: "M419.208,200.277a22.882,22.882,0,0,0,8.213-1.25c1.953-.817,3.686-3.465,4.258-6.1,0,2.117-.932,5.86-3.9,7.413s-6.415,1.635-8.581,1.692Z",
    transform: "translate(-400.804 -162.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57452",
    "data-name": "Path 57452",
    className: "cls-3",
    d: "M428.733,181.51c.817,1.545-.106,6.4-1.561,7.012s-2.975-.384-6.277-.572a23.978,23.978,0,0,0-7.355.6c-1.487.409-4.176,1.087-4.291-.409.082,3.7.817,7.911,3.49,9.268s9.578,1.635,13.141-.188,4.217-3.988,4.9-6.881a53.673,53.673,0,0,1,1.831-6Z",
    transform: "translate(-398.985 -160.788)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57453",
    "data-name": "Path 57453",
    className: "cls-3",
    d: "M425.05,177.661l2.8,1.177a1.586,1.586,0,0,0-.817-2.035,1.487,1.487,0,0,0-1.986.858Z",
    transform: "translate(-401.873 -159.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57454",
    "data-name": "Path 57454",
    className: "cls-3",
    d: "M412.211,177.323l2.844-1.136a1.471,1.471,0,0,0-1.937-.891,1.635,1.635,0,0,0-.907,2.027Z",
    transform: "translate(-399.511 -159.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57455",
    "data-name": "Path 57455",
    className: "cls-5",
    d: "M426.588,181.9a1.234,1.234,0,1,1-.329-.89A1.234,1.234,0,0,1,426.588,181.9Z",
    transform: "translate(-401.703 -160.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57456",
    "data-name": "Path 57456",
    className: "cls-5",
    d: "M414.595,181.283A1.242,1.242,0,1,1,413.4,180a1.128,1.128,0,0,1,1.193,1.283Z",
    transform: "translate(-399.508 -160.511)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57457",
    "data-name": "Path 57457",
    className: "cls-8",
    d: "M419.68,178.83l-1.022,7.878-4.168-1.536a18.454,18.454,0,0,1,5.19-6.342Z",
    transform: "translate(-399.943 -160.298)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57458",
    "data-name": "Path 57458",
    className: "cls-11",
    d: "M422.218,190.92l-3.228,1.062a1.635,1.635,0,0,0,2.117,1.136,1.773,1.773,0,0,0,1.112-2.2Z",
    transform: "translate(-400.765 -162.507)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57459",
    "data-name": "Path 57459",
    className: "cls-8",
    d: "M422.225,191.627a1.782,1.782,0,0,1,.409,0,1.749,1.749,0,0,1-1.177,1.635,1.536,1.536,0,0,1-.539.074,1.553,1.553,0,0,1,1.308-1.708Z",
    transform: "translate(-401.116 -162.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57460",
    "data-name": "Path 57460",
    className: "cls-6",
    d: "M438.4,173.871a15.071,15.071,0,0,1-1.308,4.086c-.286-.417-.621-.817-.956-1.226a25.335,25.335,0,0,0-6.963-5.533h0c-6.072-3.367-13.7-4.9-19.974-3.6a14.587,14.587,0,0,1,1.389-3.441,14.948,14.948,0,0,1,27.827,9.684Z",
    transform: "translate(-398.976 -156.205)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57461",
    "data-name": "Path 57461",
    className: "cls-6",
    d: "M434.105,158.537c-.719-.417-4.4-1.8-4.7-1.9-1.9-.727-5.034-.907-8.434,1.52a15.169,15.169,0,0,0-5.582,7.78l3.906,1.52,1.267.212c.67-2.9,4.977-8.99,10.428-8.826a4.088,4.088,0,0,1,.768.065,7,7,0,0,1,2.076.572,19.9,19.9,0,0,1,1.994,1.831,3.342,3.342,0,0,0-1.724-2.77Z",
    transform: "translate(-400.107 -156.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57462",
    "data-name": "Path 57462",
    className: "cls-12",
    d: "M434.105,158.537c-.719-.417-4.4-1.8-4.7-1.9-1.9-.727-5.034-.907-8.434,1.52a15.169,15.169,0,0,0-5.582,7.78l3.906,1.52,1.267.212c.67-2.9,4.977-8.99,10.428-8.826a4.088,4.088,0,0,1,.768.065,7,7,0,0,1,2.076.572,19.9,19.9,0,0,1,1.994,1.831,3.342,3.342,0,0,0-1.724-2.77Z",
    transform: "translate(-400.107 -156.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57463",
    "data-name": "Path 57463",
    className: "cls-6",
    d: "M421.437,168.016c.817-3.375,6.538-11.106,13.272-8.173a21.11,21.11,0,0,1,2,1.839,3.367,3.367,0,0,0-1.733-2.77c-1.733-.981-5.3-1.635-9.227,1.144a15.169,15.169,0,0,0-5.582,7.78Z",
    transform: "translate(-400.981 -156.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57464",
    "data-name": "Path 57464",
    className: "cls-13",
    d: "M421.437,168.016c.817-3.375,6.538-11.106,13.272-8.173a21.11,21.11,0,0,1,2,1.839,3.367,3.367,0,0,0-1.733-2.77c-1.733-.981-5.3-1.635-9.227,1.144a15.169,15.169,0,0,0-5.582,7.78Z",
    transform: "translate(-400.981 -156.504)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57465",
    "data-name": "Path 57465",
    className: "cls-6",
    d: "M428.323,171.12a16.7,16.7,0,0,0-6.236-6.35c-2.95-1.847-9.219-2.362-12.038-2.509-4.9-.253-6.178.711-6.293,1.43,0,.172-.147.964-.18,1.144a.7.7,0,0,0,.065.474c.662,1.169,4.511,3.375,4.511,3.375,6.277-1.283,13.893.237,19.974,3.6Z",
    transform: "translate(-397.946 -157.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57466",
    "data-name": "Path 57466",
    className: "cls-14",
    d: "M428.323,171.12a16.7,16.7,0,0,0-6.236-6.35c-2.95-1.847-9.219-2.362-12.038-2.509-4.9-.253-6.178.711-6.293,1.43,0,.172-.147.964-.18,1.144a.7.7,0,0,0,.065.474c.662,1.169,4.511,3.375,4.511,3.375,6.277-1.283,13.893.237,19.974,3.6Z",
    transform: "translate(-397.946 -157.262)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57467",
    "data-name": "Path 57467",
    className: "cls-6",
    d: "M428.126,172.549c-6.072-3.367-13.7-4.9-19.974-3.6,0,0-3.849-2.207-4.511-3.375-.351-.646.114-2.2,6.219-1.88,2.811.147,9.08.662,12.03,2.5a16.68,16.68,0,0,1,6.236,6.358Z",
    transform: "translate(-397.944 -157.523)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57468",
    "data-name": "Path 57468",
    className: "cls-13",
    d: "M428.126,172.549c-6.072-3.367-13.7-4.9-19.974-3.6,0,0-3.849-2.207-4.511-3.375-.351-.646.114-2.2,6.219-1.88,2.811.147,9.08.662,12.03,2.5a16.68,16.68,0,0,1,6.236,6.358Z",
    transform: "translate(-397.944 -157.523)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm-with-scissors--inject-2",
    transform: "translate(83.511 42.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57469",
    "data-name": "Path 57469",
    className: "cls-3",
    d: "M449.3,208.76c3.269.817,8.279,1.635,10.543,7.543,1.872,4.9,5.958,16.729,8.017,22.409,2.958,8.173,3.939,12.586,3.457,13.942-1.1,3.122-2.811,3.727-14.89,8.254-.613-3.751-5.132-8.99-7.045-9.562l6.048-4.356L447.716,230.2S443.369,214.677,449.3,208.76Z",
    transform: "translate(-446.18 -208.76)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_57470",
    "data-name": "Path 57470",
    className: "cls-6",
    d: "M446.817,168.06l4.233.319L446.7,187.821l2.991,6.113,2.689-1.046,4.4-19.614,4.233.319c.262.441.515.9.76,1.4,4.242,8.671,3.269,22.246-2.149,30.32-2.738,4.086-6.089,5.958-9.276,5.721h0l-4.217-.319a6.157,6.157,0,0,1-.817-.1L382.4,302.858c1.022,7.658-.556,16.345-4.487,22.2-2.035,3.024-4.405,4.846-6.8,5.492l-4.233-.319,4.356-19.451-2.991-6.113-2.7,1.046-4.405,19.614-4.233-.319c-.262-.441-.507-.9-.752-1.389-4.242-8.671-3.269-22.254,2.149-30.328,2.705-4.021,6.007-5.909,9.161-5.721h.131l4.086.3h0a6.6,6.6,0,0,1,.9.123l62.969-92.3c-1.022-7.649.564-16.345,4.487-22.188C442.053,170.52,444.423,168.706,446.817,168.06Z",
    transform: "translate(-345.735 -158.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57471",
    "data-name": "Path 57471",
    className: "cls-15",
    d: "M446.817,168.06l4.233.319L446.7,187.821l2.991,6.113,2.689-1.046,4.4-19.614,4.233.319c.262.441.515.9.76,1.4,4.242,8.671,3.269,22.246-2.149,30.32-2.738,4.086-6.089,5.958-9.276,5.721h0l-4.217-.319a6.157,6.157,0,0,1-.817-.1L382.4,302.858c1.022,7.658-.556,16.345-4.487,22.2-2.035,3.024-4.405,4.846-6.8,5.492l-4.233-.319,4.356-19.451-2.991-6.113-2.7,1.046-4.405,19.614-4.233-.319c-.262-.441-.507-.9-.752-1.389-4.242-8.671-3.269-22.254,2.149-30.328,2.705-4.021,6.007-5.909,9.161-5.721h.131l4.086.3h0a6.6,6.6,0,0,1,.9.123l62.969-92.3c-1.022-7.649.564-16.345,4.487-22.188C442.053,170.52,444.423,168.706,446.817,168.06Z",
    transform: "translate(-345.735 -158.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57472",
    "data-name": "Path 57472",
    className: "cls-16",
    d: "M466.593,192.169l-4.233-.319,3.8,7.764,3.424-1.332Z",
    transform: "translate(-365.626 -162.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57473",
    "data-name": "Path 57473",
    className: "cls-16",
    d: "M367.293,335.9l-4.233-.311,6.121-2.386.809,1.651Z",
    transform: "translate(-347.479 -188.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57474",
    "data-name": "Path 57474",
    className: "cls-16",
    d: "M387.913,312.034l-4.233-.319,63.779-93.486,4.233.319Z",
    transform: "translate(-351.247 -167.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57475",
    "data-name": "Path 57475",
    className: "cls-6",
    d: "M371.752,289.226,435.5,195.74c-1.022-7.65.564-16.345,4.487-22.188,2.035-3.032,4.4-4.846,6.8-5.492l-4.348,19.451,3.8,7.764,6.113-2.386,4.4-19.614c.262.441.515.907.752,1.4,4.25,8.671,3.269,22.246-2.141,30.32-3.98,5.917-9.243,7.216-13.452,4.086l-63.746,93.486c1.022,7.658-.556,16.345-4.487,22.2-2.035,3.024-4.4,4.846-6.8,5.492l4.356-19.451-3.8-7.764-6.121,2.386-4.4,19.614c-.262-.441-.507-.9-.752-1.389-4.242-8.671-3.269-22.254,2.149-30.328C362.289,287.4,367.552,286.1,371.752,289.226Z",
    transform: "translate(-345.735 -158.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57476",
    "data-name": "Path 57476",
    className: "cls-17",
    d: "M371.752,289.226,435.5,195.74c-1.022-7.65.564-16.345,4.487-22.188,2.035-3.032,4.4-4.846,6.8-5.492l-4.348,19.451,3.8,7.764,6.113-2.386,4.4-19.614c.262.441.515.907.752,1.4,4.25,8.671,3.269,22.246-2.141,30.32-3.98,5.917-9.243,7.216-13.452,4.086l-63.746,93.486c1.022,7.658-.556,16.345-4.487,22.2-2.035,3.024-4.4,4.846-6.8,5.492l4.356-19.451-3.8-7.764-6.121,2.386-4.4,19.614c-.262-.441-.507-.9-.752-1.389-4.242-8.671-3.269-22.254,2.149-30.328C362.289,287.4,367.552,286.1,371.752,289.226Z",
    transform: "translate(-345.735 -158.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57477",
    "data-name": "Path 57477",
    className: "cls-18",
    d: "M437.179,215.684,383.812,293.9a7.478,7.478,0,0,0-.736,6.652c.866,1.814,2.6,1.773,3.866-.09l53.375-78.236a7.419,7.419,0,0,0,.727-6.636C440.178,213.788,438.445,213.845,437.179,215.684Z",
    transform: "translate(-351.052 -166.774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57478",
    "data-name": "Path 57478",
    className: "cls-18",
    d: "M386.449,294.178l53.35-78.2a3.661,3.661,0,0,1,1.1-1.1,2.7,2.7,0,0,1,.613.817,7.419,7.419,0,0,1-.727,6.636L387.4,300.569a3.743,3.743,0,0,1-1.087,1.1,2.934,2.934,0,0,1-.621-.817,7.478,7.478,0,0,1,.752-6.669Z",
    transform: "translate(-351.531 -166.886)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57479",
    "data-name": "Path 57479",
    className: "cls-18",
    d: "M369.005,334.851,368.2,333.2l-6.121,2.386-4.4,19.63,4.233.319,4.405-19.639Z",
    transform: "translate(-346.494 -188.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57480",
    "data-name": "Path 57480",
    className: "cls-19",
    d: "M466.549,168.06,462.2,187.5l3.8,7.764-4.511-7.6Z",
    transform: "translate(-365.467 -158.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57481",
    "data-name": "Path 57481",
    className: "cls-19",
    d: "M369.87,360.415l5.255-19.614-4.7-7.6,3.8,7.764Z",
    transform: "translate(-348.724 -188.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57482",
    "data-name": "Path 57482",
    className: "cls-7",
    d: "M450.818,270.432c-5.2,2.354-11.311,5.108-13.452,5.99a26.741,26.741,0,0,1-10.624,1.937c-3.024,0-5.165.114-7.625-2.313a13.656,13.656,0,0,1-3.629-6.309c-.147-.874,1.381-2.117,1.381-2.117s.212-1.88,2.583-1.512,3.7,1.937,6.089,2a10.077,10.077,0,0,0,3.776-.49l1.822-2.672a28.408,28.408,0,0,1,2.918,1.316c.637.245,5.484-2.705,9.676-5.394h0C445.685,261.426,450.229,266.7,450.818,270.432Z",
    transform: "translate(-357.058 -175.29)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16733-2",
    "data-name": "Group 16733",
    transform: "translate(6143 -23723.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    className: "cls-20",
    d: "M20.137,7.793a5,5,0,0,1,8.726,0l.519.927a5,5,0,0,0,5.139,2.5l1.072-.168a5,5,0,0,1,5.442,6.737l-.541,1.4a5,5,0,0,0,1.227,5.428l1.1,1.042a5,5,0,0,1-1.942,8.4l-1.269.4a5,5,0,0,0-3.491,4.418l-.092,1.3a5,5,0,0,1-7.863,3.738l-.79-.555a5,5,0,0,0-5.75,0l-.79.555a5,5,0,0,1-7.863-3.738l-.092-1.3a5,5,0,0,0-3.491-4.418l-1.269-.4a5,5,0,0,1-1.942-8.4l1.1-1.042a5,5,0,0,0,1.227-5.428l-.541-1.4a5,5,0,0,1,5.442-6.737l1.072.168a5,5,0,0,0,5.139-2.5Z",
    transform: "translate(370 804.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check_2_",
    "data-name": "check (2)",
    className: "cls-21",
    d: "M17.236,6l-9.1,9.1L4,10.963",
    transform: "translate(383.821 818.64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon);
export default __webpack_public_path__ + "static/media/serviceIcon.a0da41e4c12ba2e1ff91f97a524617e3.svg";
export { ForwardRef as ReactComponent };